<template>
    <v-container class="list-activities-container" fluid>
        <template v-if="getLesson">
             <!-- header card -->
            <div class="card-top" >
                <!-- <v-row
                    no-gutters
                    class="align-center justify-space-between lesson-detail__header-info"
                >
                    <v-col cols="auto">
                        <v-row class="row-title align-center">

                            <v-col cols="auto">
                                <span
                                    class="list-activities-container__course text-capitalize"
                                    v-if="getLesson.subject"
                                >
                                    Aula virtual > Mis clases >
                                </span>
                            </v-col>

                            <v-col cols="auto">
                                <span
                                    class="list-activities-container__course text-capitalize"
                                    v-if="getLesson.subject"
                                >
                                 {{ capitalizeString(getLesson.subject.name) }} 

                                </span>

                            </v-col>
                            <v-col cols="auto">
                                <span
                                    class="list-activities-container__grade"
                                    v-if="getLesson.category"
                                >
                                    {{ capitalizeString(getLesson.category.name) }} 
                                </span>
                            </v-col>
                            <v-col cols="auto">
                                <span
                                    class="list-activities-container__num-students"
                                    >{{ getLesson.studentsCount }} Alumnos</span
                                >
                            </v-col>
                        </v-row>
                    </v-col>

                </v-row> -->

                <!-- Description body -->
                <v-row class="block-content align-center">
<!-- 
                    <v-col 
                    cols="2"
                    md="2" 
                    sm="2"
                    xs="2"
                    class="d-flex align-center justify-center">
                        <img
                            class="img-circle"
                            src="../../assets/images/placeholder_lesson.png"
                            alt="John"
                        />
                    </v-col> -->
                    <v-col 
                    cols="2"
                    md="2" 
                    sm="2"
                    xs="2"
                    class="d-flex align-center justify-center">
                        <v-progress-circular
                            :rotate="-90"
                            :size="140"
                            :width="8"
                            :value="getLesson.progress"
                            :color="progress(getLesson.progress)"
                            class="roma-progress"
                        >
                            <v-avatar class="roma-card__avatar-card">
                                <img 
                                    src="@/assets/images/image_card.png"
                                    alt="John"
                                />
                            </v-avatar>
                        </v-progress-circular>
                    </v-col>

                    <v-col 

                    cols="10"
                    md="10"
                    sm="10"
                    xs="10"
                    class="block-content__content"
                    >
                        <div 
                            class="text-capitalize course_category">
                            <span v-if="getLesson.subject && getLesson.subject.name"> {{ capitalizeString(getLesson.subject.name) }} </span>
                            <span v-if="getLesson.category && getLesson.category.name"> -  {{ capitalizeString(getLesson.category.name) }}  </span>
                            <span v-if="getLesson.studentsCount"> - {{ getLesson.studentsCount }} Alumnos</span>
                         
                        </div>
                        <h1 
                        v-if="getLesson.title"
                        class="block-content__title  light-blue--text">
                            {{ getLesson.title }} 
                        </h1>
                        <quillEditor
                            class="lesson-detail__quill"
                            :content="getLesson.description"
                            :options="editorOption"
                            :disabled="true"
                        />
                    </v-col>


                    <!-- code - description -->
                    <div class="actions__buttons">

                        <v-btn 
                        outlined
                        rounded
                        color="secondary"
                        class="text-center text-capitalize mr-5" 
                        v-if="activities === true"
                        @click="preview = true ; 
                                activities = false">
                            <v-icon>
                            mdi-magnify
                            </v-icon>
                            <!-- Vista previa -->
                            {{items[1]}}
                        </v-btn>

                        <v-btn 
                        outlined
                        rounded
                        color="secondary"
                        class="text-center text-capitalize mr-5" 
                        v-if="preview === true"
                        @click="preview = false ; 
                                activities = true">
                            <v-icon>
                            mdi-chevron-left
                            </v-icon>
                            Volver
                        </v-btn>


                        <v-btn
                        v-if="activities === true"
                        outlined
                        rounded
                        color="primary"
                        class="text-center text-capitalize "
                        >
                            <router-link
                                :to="{
                                    name: 'UpdateLesson',
                                    params: { id: $route.params.id }
                                }"
                                color="transparent"
                                class="text-capitalize text-decoration-none"
                            >
                                <v-icon>mdi-pencil</v-icon>
                                <span >
                                    Editar Clase
                                </span>
                            </router-link>
                        </v-btn>

                        
                         <v-btn
                             v-if="groupActivities && groupActivities.length
                               && preview === true"
                                rounded
                                color="accent"
                                class="text-center text-capitalize "
                                @click="redirectToFirstResourceActivity(groupActivities[0].activityTOS[0])"
                            >
                                <v-icon >roma-icon-rocket</v-icon>
                                <span>Empezar</span>
                        </v-btn>


                    </div>
                </v-row> 
            </div>


            <!-- content  -->
            <div class="roma-page-content">

                 <!-- content subititle  -->
                <v-row
                
                v-if="activities === true"
                class="d-flex justify-space-between mt-5">
                    <div
                    >
                     <!-- Actividades -->

                        <p class="activities_title">
                            {{items[0]}}
                        </p>
                        
                    </div>

                    <!-- <v-spacer></v-spacer> -->
                    <div
                    >
                        <template v-if="getActivities.length">
                            <v-btn
                                rounded
                                class="text-capitalize"
                                style="background-color:#FF7F00;color:white;"
                                v-if="activities === true"
                                :to="{
                                    name: 'NewActivity',
                                    params: {
                                        id: false
                                    }
                                }"
                            >
                                <v-icon  >icon-dp-activity-white</v-icon>
                                <span class="">
                                    Crear Actividad
                                </span>
                            </v-btn>
                        </template>
                    </div>
                </v-row>

            <!-- activity list -->
            <v-row class="mb-5 justify-space-between">
                <!-- trigger new activity -->

                <!-- tabs -->
                <v-col cols="12" no-padding style="padding:12px 0;">
                    <!-- <v-tabs-items v-model="tab" class="transparent">
                        <v-tab-item v-for="item in items" :key="item"> -->
                            <!-- Activities list -->
                            <template v-if="getActivities.length">

                                <div v-if="activities === true">
                                    <template
                                        v-for="(activity, i) in getActivities"
                                    >
                                        <v-card
                                            class="
                                            mb-5
                                            card-list-activity activity"
                                            :key="i"
                                        >
                                         <v-hover v-slot="{ hover }">
                                            <v-card
                                            :elevation="hover ? 6 : 1"
                                            :class="{ 'on-hover': hover }"
                                            class="card-content-list">
                                                <v-row cols="12" 
                                                @click="editActivity(activity)"
                                                class="
                                                    wrapper-row
                                                    d-flex 
                                                    flex-wrap
                                                    align-center justify-space-between">

                                                    <div class="
                                                    
                                                    d-flex align-center"
                                                    >
                                                       
                                                        <v-icon
                                                        color="light-blue">
                                                        mdi-text-box-outline
                                                        </v-icon>
                                                       
                                                            <span
                                                                class="
                                                                activity-title
                                                                ml-4"
                                                                >{{
                                                                    activity.title
                                                                }}</span
                                                            >
                                                    </div>
                                                    

                                                    <div class="
                                                    d-flex align-center">
                                                        
                                                        <div class="activity-code">
                                                            <span
                                                                >{{
                                                                    activity.code
                                                                }}
                                                            </span>
                                                        </div>
                                                        <div class="activity-name">
                                                            
                                                            <span
                                                                class="ml-4 "
                                                            >
                                                            {{activity.activityTypeTO['name']}}
                                                            </span>
                                                        </div>

                                                        <div  class="activity-deadline"
                                                        v-if="activity.deadline  && humanReadeableDate(activity.deadline) != '01-01-1970'">
                                                            <span
                                                                class="ml-4 cardTitle--text "
                                                            >
                                                            {{humanReadeableDate(activity.deadline)}}
                                                            </span>
                                                        </div>
                                                        <div  class="activity-deadline"
                                                        v-else>
                                                            <span
                                                                class="ml-4 cardTitle--text "
                                                            >
                                                            </span>
                                                        </div>

                                                        <div
                                                        
                                                            class="custom-dots"
                                                        >
                                                            <RomaOptionsDropdown
                                                                :options="
                                                                    dropDownOptions
                                                                "
                                                                :activityId="
                                                                    activity.activityLessonId
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                </v-row>
                                            </v-card>
                                        </v-hover>
                                        </v-card>
                                    </template>
                                </div>
                            </template>
                            <!-- no Activities -->
                            <template v-else>
                                <v-col v-if="activities === true">
                                    <v-row class="mtc-5">
                                        <v-col
                                            class="text-center no-activities"
                                            cols="12"
                                        >
                                            <img
                                                src="../../assets/images/Ilustracion No tiene actividades.svg"
                                                alt
                                                class="no-activities__img"
                                            />
                                        </v-col>
                                        <v-col cols="12" class="text-center">
                                            <v-btn
                                                color="accent"
                                                class="roma-btn-2 text-capitalize"
                                                :to="{
                                                    name: 'NewActivity',
                                                    params: {
                                                        id: false
                                                    }
                                                }"
                                                rounded
                                                large
                                            >
                                                <span>
                                                    Crear Actividad
                                                </span>
                                                <v-icon right dark class=""
                                                    >icon-dp-activity-white</v-icon
                                                >
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </template>
                            <!-- preview tab -->
                            <template v-if="preview === true">
                                <RomaActivitiesPreview />
                            </template>
                </v-col>
            </v-row>
            </div>
        </template>
    </v-container>
</template>
<script>
// import RomaFilter from "@/components/commons/RomaFilter.vue";
// import RomaFilterActivities from "@/components/commons/RomaFilterActivities";
import RomaActivitiesPreview from "@/components/activity/RomaActivitiesPreview";
import RomaOptionsDropdown from "../activity/DropdownCardActivity";
// import Modal from "@/components/commons/RomaMainModal.vue";

import FormNewActivity from "@/components/activity/RomaFormNewActivity.vue";
import FormNewLesson from "@/components/lesson/RomaFormNewLesson.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { mapActions, mapGetters } from "vuex";
import Vue from 'vue';
import VuetifyConfirm from 'vuetify-confirm';
import Vuetify from "vuetify/lib";
Vue.use(Vuetify);
const vuetify = new Vuetify({theme:{}});
Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: 'Aceptar',
  buttonFalseText: 'Cancelar',
  color: 'warning',
  icon: '',
  title: '',
  width: 350,
  property: '$confirm'
})

export default {
    data() {
        return {
            editorOption: {
                readOnly: true,
                modules: {
                    toolbar: false
                },
                placeholder: ''
            },
            modalOptionsActivity: {
                updateMode: false
            },
            modalOptionsLesson: {
                updateMode: true
            },
            course: "Lenguaje y Comunicación",
            grade: "4to Básico A",
            alumns: 0,
            classCode: "Código de clase",
            title: "El Cuento",
            empty: false,
            dropDownOptions: [
                {
                    title: this.$vuetify.lang.t("Editar actividad"),
                    icon: "mdi-pencil",
                    status: true,
                    action: param => {
                        this.$router.push({
                            name: "UpdateActivity",
                            params: { id: param }
                        });
                    }
                },
                {
                    title: this.$vuetify.lang.t("Vista Previa"),
                    icon: "mdi-eye",
                    status: true,
                    action: param => {
                        this.$router.push({
                            name: "PreviewActivity",
                            params: { id: param }
                        });

                        // this.tab = 1;
                    }
                },
                /*{ 
                    title: this.$vuetify.lang.t("Cerrar"),
                    icon: "mdi-checkbox-blank-circle ",
                    status: true,
                    action: () => {
                        console.info("hey 3");
                    }
                },*/
                {
                    title: this.$vuetify.lang.t("Eliminar actividad"),
                    icon: "mdi-delete",
                    status: true,
                    action: activityId => {
                        this.deleteActivity(activityId);
                    }
                }
            ],
            optionsFilter: [
                {
                    label: this.$vuetify.lang.t("Asignatura"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Nivel"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Curso"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Unidad"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Título"),
                    type: "text",
                    cols: 6,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Fecha entrega inicio"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Fecha entrega fin"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Pie"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Estado"),
                    type: "select",
                    cols: 3,
                    options: []
                }
            ],
            tab: null,
            items: ["Actividades", "Vista Previa"],
            activities: true,
            preview:false,
            switch:true
        };
    },
    async mounted() {
        this.setLesson({});
        this.setActivities([]);
        await this.actionGetLesson(this.$route.params.id);
        await this.getActivitiesByLessonId(this.$route.params.id);
        await this.getActivitiesByGroupTypeLessonId(this.$route.params.id);

        // Ordenando recursos con actividades para 
        this.activityWithResourceSort();
    },
    computed: {
        ...mapGetters({
            getUserData: "getUserData",
            getLesson: "getLesson",
            getActivities: "getActivities",
            getActivitiesByGroup: "getActivitiesByGroup",
            getCurrentResources: "getCurrentResources",

        }),
        groupActivities() {
             return this.getActivitiesByGroup.length ? this.getActivitiesByGroup : [];
    }
    },
    components: {
        RomaOptionsDropdown,
        quillEditor,
        RomaActivitiesPreview
        // RomaFilterActivities
    },
    methods: {
        ...mapActions({
            actionGetLesson: "actionGetLesson",
            setLesson:"setOneLesson",
            setActivities:"setActivities",
            getActivitiesByLessonId: "getActivitiesByLessonId",
            getActivitiesByGroupTypeLessonId: "getActivitiesByGroupTypeLessonId",
            actionSetCurrentResources: "actionSetCurrentResources",
            actionDeleteActivity: "actionDeleteActivity",
            toastSuccess: "toastSuccess",
            toastError: "toastError",
            // actionGetLesson: "actionGetLesson",
            actionSetCurrentActivity: "actionSetCurrentActivity",
            actionSetCurrentResource: "actionSetCurrentResource",
            // getActivitiesByLessonId: "getActivitiesByLessonId",
            actionSetResourcePaginationIndex: "actionSetResourcePaginationIndex",
            actionResetCurrentResources: "actionResetCurrentResources"
        }),
        getComponent(name) {
            if (name === "activity") {
                return FormNewActivity;
            } else {
                return FormNewLesson;
            }
        },
        capitalizeString(string) {
            const value = string;
            return value.toLowerCase();
        },
        humanReadeableDate(string){
            const d = new Date(string);
            let month = '' + (d.getMonth() + 1);
            let day = '' + d.getDate();
            const year = d.getFullYear();

            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;

            return [day, month,year].join('-');
     
        },
        progress(value) {
	    //   console.log("Valor progreso:"+value);
		      if (value <= 25) {
		        this.color = "secondary";
		      } else if (value >= 26 && value <= 49) {
		        this.color = "purple";
		      } else if (value >= 50 && value <= 75) {
		        this.color = "accent";
		      } else if (value >= 76 && value <= 90) {
		        this.color = "blueMedium";
		      } else {
		        this.color = "success";
		      }
		      return this.color;
	    },

        editActivity(activity){
            const id = activity.activityLessonId
            this.$router.push({ name: 'UpdateActivity', params: { id } }) 
        },

        async searchFirstResourceIndexForActivity(activity) {
        const index = await this.getCurrentResources.findIndex((resource) => resource.activity.activityLessonId === activity.activityLessonId);
        console.log(index);
        this.actionSetResourcePaginationIndex(index);
        this.redirectToResource(this.getCurrentResources[index]);
        },
        redirectToFirstResourceActivity(activity) {
        console.info("ACTIVIDAD", activity);
        this.searchFirstResourceIndexForActivity(activity);
        },
        redirectToResource(resource) {
        // Guardando recurso actual en vuex
        try {
            this.actionSetCurrentResource(resource);

            this.$router.push({ 
                name: 'ActivityType', 
                params: {
                id: resource.resourcesId,
                type: this.getUrlActivity(resource.resourceType.type)
                }
            })
        } catch (error) {
            console.log(error);
        }

        },

        deleteActivity(activityId) {

        this.$confirm('¿está seguro de eliminar esta actividad?', { title: 'Confirmación', buttonTrueText: 'Aceptar', buttonFalseText: 'Cancelar'}).then(res => {

            if(res){

                this.actionDeleteActivity(activityId)
                .then(res => {
                    this.toastSuccess({
                        message: `Se ha eliminado la Actividad`
                    });
                    this.getActivitiesByLessonId(this.getLesson.lessonId);
                })
                .catch(err => {
                    this.toastError({
                        message: `Error al eliminar Actividad`
                    });
                });

            }

        });



        },

        activityWithResourceSort() {
            const arrayResourcesWithActivity = [];

            console.info("### GROUP ", this.getActivitiesByGroup);

            this.getActivitiesByGroup.forEach( activityGroup => {

                activityGroup.activityTOS.forEach( (activityTo, i) => {

                // Quitar recursos para evitar anidarlos nuevamente
                delete activityTo.resourceTypeTO;

                // datos basicos de la actividad
                const auxActivity = {
                    activityLessonId: activityTo.activityLessonId, 
                    code : activityTo.code,
                    lessonId: activityTo.lessonId,
                    title : activityTo.title,
                    isTask: activityTo.isTask,
                    instructive: activityTo.instructive,
                };

                activityTo.resourcesTo.forEach( (resourceTo, i) => {

                    // seteando datos basicos de actividad dentro de cada recurso
                    resourceTo.activity = auxActivity;

                    // llenando array de recursos con datos de la actividad
                    arrayResourcesWithActivity.push(resourceTo);
                })
                })

            });

            console.info("RECOURCES AUX", arrayResourcesWithActivity);

            this.actionSetCurrentResources(arrayResourcesWithActivity);

            },
    }
};
</script>

<style lang="scss">
.tab-btn {
    font-size: 20px;
    color: #818181 !important;
}
.roma-icon-rocket:before {
    background-color:#FF7414 ;
    content: url("../../assets/icons/spring-swing-rocket.svg");
  }
.list-activities-container {
    margin: 0  !important;
    padding:0 !important;
    width: 100%;

    .roma-page-content{
        padding-top:0px ;
    }

    .activities_title{
       color: #3a8fce ;
       font-size: 24px;
    }



    .card-top{
        background-color: white;
        /* width: 100%; */
        padding: 15px;
    }

    .lesson-detail__header-info {
        position: relative;
    }
    .lesson-detail__quill {
        color: #7F7F7F;
        .ql-container.ql-snow.ql-disabled {
            border: none;
        }
        // background-color: #bada55;
        * {
            font-family: "Cabin", sans-serif !important;
            font-weight: normal;
            font-size: 18px;
        }
    }
    .v-tab::before {
        border-radius: 33px !important;
    }
    .course_category{
        color: #616161;
        font-size: 16px;
    }
    &__course,
    &__grade,
    &__professor-name,
    &__num-students {
        font-size: 20px !important;
        color: #040404;
    }
    &__professor-name {
        color: #3e3e3e;
    }
    .custom-tab {
        .v-slide-group__content.v-tabs-bar__content {
            // justify-content: space-between;
            justify-content: center;
        }
    }
    .container {
        padding: 5px 0 0 5px;
    }
    .filter-container {
        // left: 25%;
        // width: 60%;
        // top: 12%;
        // border-radius: 35px;
    }

    .no-padding {
        padding: 0 !important;
    }

    .row-title {
        font-size: 1.1em;
    }

    .block-content {
        margin: 15px;
        position: relative;
            .actions__buttons{
                position: absolute;
                top: 0;
                right: 0px;
            }
        // color: map-get($colors, "text");
        .img-circle {
            border-radius: 100%;
            width: 120px;
            height: auto;
            filter: drop-shadow(0px 6px 15px #00000029);
        }
        &__code {
            color: #040404;
            font-size: 20px;
        }
        &__title {
            font-size: 32px;
        }
        &__description {
            color: #000000;
            font-size: 18px;
        }
        &__code,
        &__title,
        &__description {
        }
    }

    h1 {
        padding: 8px 0;
        color: map-get($colors, "primary");
        font-weight: normal;
    }

    .v-tab {
        color: #818181 !important;
        text-transform: capitalize;
        background: transparent !important;
        border: none !important;
        box-shadow: none;
        font-weight: normal;
        font-size: 1.25em;
        line-height: 1.5em;
        padding: 0 6px !important;
        .v-tab:hover {
            box-shadow: none !important;
            background: transparent !important;
        }

        .v-tab-modal {
            color: #818181 !important;
            text-transform: capitalize;
            background: transparent !important;
            border: none !important;
            box-shadow: none;
            font-weight: normal;
            line-height: 1.25em;
            padding: 0 6px !important;
            font-size: 1em !important;
        }

        .v-tab-modal:hover {
            box-shadow: none !important;
            background: transparent !important;
        }
    }

    .v-tab--active {
        color: #3a8fce !important;
    }

    .v-tabs-slider {
        background-color: transparent;
    }

    .btn-create {
        text-transform: capitalize;
        font-size: 1.5em;
        padding: 15px 40px !important;
        border-radius: 100px !important;
        height: 70px !important;
        img {
            margin-left: 15px;
        }
    }

    .actions {
        float: right;
        a {
            text-decoration: none;
            color: #818181 !important;
            text-transform: capitalize;
        }
        button {
            color: #818181 !important;
            text-transform: capitalize;
            background: transparent !important;
            border: none !important;
            box-shadow: none;
            font-weight: normal;
            font-family: "Roboto";
            font-size: 1.25em;
            line-height: 1.5em;
            padding: 0 6px !important;
        }
        button:hover {
            box-shadow: none !important;
            background: transparent !important;
        }
        .active {
            color: #3a8fce !important;
        }
    }

    h2 {
        padding: 15px 0 15px 10px;
        color: map-get($colors, "primary");
        font-weight: normal;
        font-size: 2em;
    }

    .card-content-list {
        cursor: pointer;
        padding: 20px 2% 10px 6%;
        .wrapper-row{
            color: #535353;
            .activity-title{
                width: 100%;
                /* width:200px;    */
            }
            .activity-name{
                width:120px; 
            }
            .activity-code{
            }
            .activity-deadline{
                width:120px; 
            }
        }
    }

    .card-content-list-comments {
        padding: 10px 2% 10px 6%;
    }
    .activity {
        box-shadow: 0px 3px 6px #00000029 !important;
        &__code {
            font-size: 15px;
            color: #707070;
        }
        &__title {
            font-size: 25px;
        }
        &__date {
            font-size: 18px;
        }
        .custom-dots {
            div:first-child {
                text-align: right !important;
            }
        }
    }

    .transparent {
        background: transparent;
        border: none !important;
        box-shadow: none;
    }

    .input-comments {
        i {
            color: map-get($colors, "accent") !important;
        }
    }

    .md-10 {
        width: 90%;
    }

    .md-1 {
        width: 5%;
    }

    .btn-clear {
        padding: 0 5px;
        i {
            color: map-get($colors, "accent") !important;
        }
    }
    .ql-editor {
        padding: 0 !important;
        margin: 0 !important;
    }
    @media (max-width: 599px) {

        &__course,
        &__grade,
        &__num-students {
            font-size: 9px !important;
        }
        .block-content {
            margin: 10px;
            &__title {
                font-size: 17px;
            }
            .img-circle {
                width: 60px;
            }
            &__content{
                margin-top: 5px;
            }
        }
        .lesson-detail__quill {
            * {
                font-size: 10px;
            }
        }
        .roma-btn-2 {
            .v-btn__content {
                font-size: 11px;
            }
        }
        .v-tab.v-tab,
        .tab-btn {
            font-size: 11px;
        }
        .no-activities {
            &__title {
                font-size: 14px;
            }
            &__img {
                width: 150px;
                height: auto;
            }
        }
        .title-card.title-card {
            font-size: 12px;
            .v-icon {
                display: none;
            }
        }
        .activities_title{
            color: #3a8fce ;
            font-size: 18px;
        }
        .roma-page-content{
            margin:10px;
            padding: 0 10px ;
         }
        .actions__buttons{
            top: initial  !important;
            bottom: -25px;
            right: 0;
        }
        .card-top{
        padding-bottom: 25px !important;
        }
        .course_category{
        font-size: 12px;
        }
        .activity-name{
        font-size: 12px;
        }
        .activity-code{
        font-size: 12px;
        }
        .custom-dots {
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }
}
@media (max-width: 365px) {
    .actions__buttons{
        button{
            max-width: 120px !important;
        }
    }
}
</style>
